import RegularText from "@/components/RegularText";
import { SETTING_TYPE } from "@/constants/enum";
import { handleSaveWidgetTextDetail, widgetTextDetailSelector } from "@/redux/slice/widgetText.slice";
import { Box, TextField } from "@shopify/polaris";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

export const ErrorMessage = () => {
    const { t } = useTranslation('translation');
    const dispatch = useDispatch();

    const widgetTextDetail = useSelector(widgetTextDetailSelector);
    const text = widgetTextDetail?.texts?.find((text) => text.type === SETTING_TYPE.SHIPPING);

    const handleChangeTranslation = useCallback(
        (key: string, value: string) => {
            dispatch(
                handleSaveWidgetTextDetail({
                    texts: widgetTextDetail?.texts?.map((text) => {
                        if (text.type === SETTING_TYPE.SHIPPING) {
                            return {
                                ...text,
                                errorMessages: {
                                    ...text.errorMessages,
                                    [key]: value,
                                },
                            };
                        }
                        return text;
                    }),
                }),
            );
        },
        [dispatch, widgetTextDetail],
    );

    return (
        <>
            <Box>
                <RegularText fontWeight="medium">Error messages</RegularText>
                <TextField
                    label={t('cartPage.shipping.eligibleMessage')}
                    value={text?.errorMessages?.eligibleMessage}
                    onChange={(value: string) => handleChangeTranslation('eligibleMessage', value)}
                    autoComplete="off"
                />
            </Box>
        </>
    );
};
